<span [className]="'dui-badge ' + (isSolid ? 'solid ' : '') + color">
    <ng-content></ng-content>
</span>
